import React from 'react';
import "./Footer.css";

function Footer() {
  return (
    <section className="f-wrapper">
        <div className="paddings innerWidth flexCenter f-container">
            {/* Left Side */}
            <div className="flexColStart f-left">
                <img src="./logo.jpeg" alt="Company logo" width={120} />

                <span className="secondaryText">Our Vision Is To Help Find The Best Property For You.</span>
            </div>

            {/* Right Side */}
            <div className="flexColStart f-right">
                <span className="primaryText">Information</span>
                <span className='secondaryText'>Pune, Maharashtra</span>

                <div className="flexCenter f-menu">
                    <span>Property</span>
                    <span>Services</span>
                    <span>Product</span>
                    <span>About Us</span>
                </div>
            </div>
        </div>
        <span className='paddings innerWidth flexCenter secondaryText'>&copy; Aura. All rights reserved.</span>
    </section>
  )
}

export default Footer
